import React, { useState, useEffect } from "react";
import "./App.css";
import Navbar from "./components/navbar/Navbar";
import BackgroundPart from "./components/backgroundPart/BackgroundPart";
import AboutMePart from "./components/aboutMePart/AboutMePart";
import MyProjectsPart from "./components/myProjectsPart/MyProjectsPart";
import MySkillsPart from "./components/mySkillsPart/MySkillsPart";
import ContactMePart from "./components/contactMePart/ContactMePart";
import PageFooter from "./components/pageFooter/PageFooter";
import MyInterestsPart from "./components/myInterestsPart/MyInterestsPart";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import "./styles/variables.css";

function App() {
    const [hasVisitedBefore, setHasVisitedBefore] = useState<boolean | null>(
        null
    );

    useEffect(() => {
        // Check if user has visited before
        const visited = localStorage.getItem("hasVisitedBefore");
        console.log("localStorage visited value:", visited);

        if (visited === "true") {
            console.log("User has visited before");
            setHasVisitedBefore(true);
        } else {
            console.log("First-time visitor, setting localStorage");
            // Set flag for future visits
            localStorage.setItem("hasVisitedBefore", "true");
            setHasVisitedBefore(false);
        }
    }, []);

    // Only render the app once we've checked localStorage
    if (hasVisitedBefore === null) {
        return null; // Or a loading spinner if preferred
    }

    return (
        <div className="App">
            <Navbar />
            <BackgroundPart skipAnimation={hasVisitedBefore} />
            <div id="about">
                <AboutMePart />
            </div>
            <div id="projects">
                <MyProjectsPart />
            </div>
            <div id="skills">
                <MySkillsPart />
            </div>
            <div id="interests">
                <MyInterestsPart />
            </div>
            <div id="contact">
                <ContactMePart />
            </div>
            <PageFooter />
            <Analytics />
            <SpeedInsights />
        </div>
    );
}

export default App;
